import React from 'react';

const Header = () => {
  return (
    <div>
      {/* Your header content goes here */}
    </div>
  );
}

export default Header;
